<template>
    <modal :show.sync=show modalClasses="modal-hide-footer">
        <div class="card-table">
            <CommitmentScenario :tables="tables" :isfull="true"/>
        </div>
    </modal>
</template>
<script>
import CommitmentScenario from '../Partials/CommitmentScenario.vue';
export default {
    props:['loanInformation', 'show_full_view', 'tables'],
    components: {
        CommitmentScenario
    },
    data() {
        return {
            tableData: this.loanInformation
        }
    },
    computed: {
        show: {
            get() {
                return this.show_full_view;
            },
            set(value) {
                this.$emit('update:show_full_view', value);
            }
        },
    }
}
</script>